<template>
    <div class="invite-user">
        <div style="margin: 0 0 15px 0 ;">用户信息</div>
        <el-table :data="curInviteList" size="small" border fit highlight-current-row>
            <el-table-column prop="id" align="center" label="ID" min-width="60" />

            <el-table-column prop="name" label="昵称" min-width="80" align="center" />

            <el-table-column prop="subordinate_num" label="邀请人数" min-width="80" align="center" />

            <el-table-column prop="online_num" label="下级产品体验参与统计" min-width="150" align="center" />

            <el-table-column prop="offline_num" label="下级探店体验参与统计" min-width="150" align="center" />

            <el-table-column prop="activity_user_num" label="下级线下活动参与统计" min-width="150" align="center" />

            <el-table-column prop="merchant_activity_num" label="下级参与商户活动" min-width="140" align="center" />

            <!-- <el-table-column label="操作" align="center" width="230">
                <template slot-scope="scope">
                    
                </template>
            </el-table-column> -->
        </el-table>
        <div class="lower-level-box">
            <div class="level-menu">
                <div v-for="item, index in menuList" :key="index" class="menu-item" :class="item.active ? 'active' : ''"
                    @click="clickMenu(item, index)">{{ item.title }}</div>
            </div>

            <div class="search_box">
                <div style="margin:5px 15px 0 0">
                    <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
                    </el-date-picker>
                </div>

                <div style="margin:5px 15px 0 0" v-if="currIndex === 3">
                    <el-select v-model="listQuery.sort_type" placeholder="排行" clearable style="min-width: 210px;">
                        <!-- <el-option label="按邀请人数排行" :value="1" /> -->
                        <el-option label="按参与产品体验排行" :value="2" />
                        <el-option label="按参与探店体验排行" :value="3" />
                        <el-option label="按参与线下活动排行" :value="4" />
                        <el-option label="按商户活动人数排行" :value="5" />
                    </el-select>
                </div>

                <el-button style="margin:5px 15px 0 0" type="primary" :loading="listLoading" icon="el-icon-search"
                    @click="handleFilter">搜索</el-button>
                <el-button style="margin:5px 15px 0 0" type="warning" :loading="listLoading" icon="el-icon-upload2"
                    @click="exportExcel">导出Excel</el-button>
            </div>
            <!-- table -->
            <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border
                max-height="450px" highlight-current-row>


                <template v-if="currIndex === 3">
                    <el-table-column prop="id" align="center" label="ID" min-width="60" />

                    <el-table-column prop="name" label="用户名称" min-width="80" align="center" />

                    <el-table-column prop="wx_id" label="微信ID" min-width="80" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.wx_id">
                                {{ scope.row.wx_id }}
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="account" label="手机号" min-width="80" align="center" />
                    <el-table-column prop="email" label="邮箱" min-width="80" align="center" />
                    <el-table-column label="性别" min-width="50" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.gender === 0 || scope.row.gender === null">未设置</span>
                            <span v-else-if="scope.row.gender === 1">男</span>
                            <span v-else-if="scope.row.gender === 2">女</span>
                            <span v-else>后端无字段</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年龄段" min-width="60" align="center">
                        <template slot-scope="scope">
                            <div>{{
                                scope.row.age_group === 1 ? '20岁以下' :
                                    scope.row.age_group === 2 ? '21~30岁' :
                                        scope.row.age_group === 3 ? '31~40岁' :
                                            scope.row.age_group === 4 ? '41~50岁' :
                                                scope.row.age_group === 5 ? '51岁以上' : '未设置'
                            }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="居住地" min-width="80" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.country && scope.row.provinces">
                                {{ scope.row.country }} ，{{ scope.row.provinces }}
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="online_num" label="参与产品体验统计" min-width="120" align="center" />

                    <el-table-column prop="offline_num" label="参与探店体验统计" min-width="120" align="center" />

                    <el-table-column prop="activity_user_num" label="参与线下活动统计" min-width="120" align="center" />

                    <el-table-column prop="merchant_activity_num" label="参与商户活动统计" min-width="120" align="center" />

                    <el-table-column prop="created_at" label="注册时间" align="center" width="150">
                        <!-- <template slot-scope="scope">

                        </template> -->
                    </el-table-column>
                </template>

                <template v-else>

                    <el-table-column prop="user_info.id" align="center" label="ID" min-width="60" />

                    <el-table-column prop="user_info.name" label="用户名称" min-width="80" align="center" />

                    <el-table-column prop="user_info.wx_id" label="微信ID" min-width="80" align="center">
                        <template slot-scope="scope" v-if="scope.row.user_info">
                            <div v-if="scope.row.user_info.wx_id">
                                {{ scope.row.user_info.wx_id }}
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_info.account" label="手机号" min-width="80" align="center" />
                    <el-table-column prop="user_info.email" label="邮箱" min-width="80" align="center" />
                    <el-table-column label="性别" min-width="50" align="center">
                        <template slot-scope="scope" v-if="scope.row.user_info">
                            <span v-if="scope.row.user_info.gender === 0 || scope.row.user_info.gender === null">未设置</span>
                            <span v-else-if="scope.row.user_info.gender === 1">男</span>
                            <span v-else-if="scope.row.user_info.gender === 2">女</span>
                            <span v-else>后端无字段</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年龄段" min-width="60" align="center">
                        <template slot-scope="scope" v-if="scope.row.user_info">
                            <div>{{
                                scope.row.user_info.age_group === 1 ? '20岁以下' :
                                    scope.row.user_info.age_group === 2 ? '21~30岁' :
                                        scope.row.user_info.age_group === 3 ? '31~40岁' :
                                            scope.row.user_info.age_group === 4 ? '41~50岁' :
                                                scope.row.user_info.age_group === 5 ? '51岁以上' : '未设置'
                            }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="居住地" min-width="80" align="center">
                        <template slot-scope="scope" v-if="scope.row.user_info">
                            <div v-if="scope.row.user_info.country && scope.row.user_info.provinces">
                                {{ scope.row.user_info.country }} ，{{ scope.row.user_info.provinces }}
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>

                    <template v-if="currIndex === 2">
                        <el-table-column label="活动名称" min-width="80" align="center">
                            <template slot-scope="scope" v-if="scope.row.activity_info">
                                {{ scope.row.activity_info.name }}
                            </template>
                        </el-table-column>

                        <el-table-column label="活动封面" min-width="120" align="center">
                            <template slot-scope="scope" v-if="scope.row.activity_info">
                                <img style="width:100px; height: 100px;object-fit: cover;"
                                    :src="scope.row.activity_info.cover_img" alt="活动封面">
                            </template>
                        </el-table-column>
                    </template>

                    <template v-else>
                        <el-table-column label="活动名称" min-width="80" align="center">
                            <template slot-scope="scope" v-if="scope.row.evaluation">
                                {{ scope.row.evaluation.name }}
                            </template>
                        </el-table-column>

                        <el-table-column label="活动封面" min-width="120" align="center">
                            <template slot-scope="scope" v-if="scope.row.evaluation">
                                <img style="width:100px; height: 100px;object-fit: cover;"
                                    :src="scope.row.evaluation.cover_img" alt="活动封面">
                            </template>
                        </el-table-column>

                        <el-table-column label="是否商户活动" min-width="110" align="center">
                            <template slot-scope="scope" v-if="scope.row.evaluation">
                                <el-tag v-if="scope.row.evaluation.is_merchant_activity === 1" type="success">是</el-tag>
                                <el-tag v-else type="danger">否</el-tag>
                            </template>
                        </el-table-column>
                    </template>


                    <el-table-column prop="created_at" label="参与时间" align="center" width="150">
                        <!-- <template slot-scope="scope">

                        </template> -->
                    </el-table-column>
                </template>






            </el-table>
            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>

<script>
// 邀新转化 邀新列表
import { subordinateList } from "@/api/statistic"
import * as XLSX from "xlsx";
export default {
    data() {
        return {
            list: [],
            listLoading: false,
            isListFlag: false,
            currIndex: 0,
            filteDateRange: [],
            menuList: [
                {
                    title: '参与产品体验',
                    active: false,
                },
                {
                    title: '参与探店体验',
                    active: false,
                },
                {
                    title: '参与线下活动',
                    active: false,
                },
                {
                    title: '邀新列表',
                    active: true,
                },
            ],
            listQuery: {
                page: 1,
                limit: 10,
                start_at: null,
                end_at: null,
                sort_type: null,
                type: 1,
            },
            total: 0,
        }
    },
    props: {
        curInviteObj: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        curInviteList() {
            return [this.curInviteObj]
        }
    },
    created() {
        this.menuList.forEach((item, index) => {
            if (item.active) {
                this.currIndex = index
                // if (index === 3) {
                //     this.isListFlag = true
                // } else {
                //     this.isListFlag = false
                // }
            }
        })
        this.listQuery.user_name = this.curInviteObj.name
        this.listQuery.id = this.curInviteObj.id
        this.getList();
    },
    methods: {
        async getList() {
            this.listLoading = true;
            this.list = []
            const { data } = await subordinateList(this.listQuery)
            // if (this.currIndex === 3) {
            // }
            this.list = data.data;
            this.total = data.total;
            console.log('this.list', this.list)
            this.listLoading = false;
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.start_at = null
                this.listQuery.end_at = null
                return
            }
            this.listQuery.start_at = t[0]
            this.listQuery.end_at = `${t[1].split(' ')[0]} 23:59:59`
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        clickMenu(item, index) {
            let flag = false // 点击自己不做操作
            this.menuList.forEach((item, i) => {
                if (item.active && index === i) {
                    flag = true
                }
                item.active = false
            });
            item.active = true
            if (flag) return false

            this.setData()
            this.currIndex = index;
            if (index === 0) {
                this.listQuery.type = 2
            } else if (index === 1) {
                this.listQuery.type = 3
            } else if (index === 2) {
                this.listQuery.type = 4
            } else if (index === 3) {
                this.listQuery.type = 1
            }
            this.getList();
        },
        setData() {
            this.listQuery.page = 1
            this.listQuery.limit = 10
            this.listQuery.sort_type = ''
            this.listQuery.start_at = ''
            this.listQuery.end_at = ''
            this.filteDateRange = []

        },
        async exportExcel() {
            console.log('exportExcel',this.listQuery.type)
            // 修改excel-邀新转化-下级列表-按搜索结果导出Excel---ok
            const { total } = this
            if (!total) return
            let excelTitle = ''
            this.menuList.forEach((item,index) =>{
                if(this.currIndex === index){
                    excelTitle = item.title
                }
            })
            try {
                    const { data: { data: reqData } } = await subordinateList({ ...this.listQuery, page: 1, limit: 99999999999 })
                    console.log(reqData);

                    var wb = XLSX.utils.book_new();

                    var excelData = []

                    if(this.listQuery.type === 1){ // 邀新列表
                        excelData = [
                            ['ID', '用户名称', '微信ID', '手机', '邮箱', '性别', '年龄', '居住地', '参与产品体验统计', '参与探店体验统计', '参与线下活动统计', '参与商户活动统计', '注册时间'],
                            ...reqData.map((item) => [item.id, item.name, item.wx_id, item.account, item.email, item.gender === 1 ? '男性' : item.gender === 2 ? '女性' : '未设置', 
                            item.age_group === 1 ? '20岁以下' : item.age_group === 2 ? '21~30岁' : item.age_group === 3 ? '31~40岁' : item.age_group === 4 ? '41~50岁' : item.age_group === 5 ? '51岁以上' : '未设置',
                            item.country+','+item.provinces, item.online_num, item.offline_num, item.activity_user_num, item.merchant_activity_num, item.created_at])
                        ];
                    }else if(this.listQuery.type === 4){ //参与线下活动
                        excelData = [
                            ['ID', '用户名称', '微信ID', '手机', '邮箱', '性别', '年龄', '居住地', '活动名称', '参与时间'],
                            ...reqData.map((item) => [item.user_info.id, item.user_info.name, item.user_info.wx_id, item.user_info.account, item.user_info.email, item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置', 
                            item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' :  '未设置',
                            item.user_info.country+','+item.user_info.provinces, item.activity_info ? item.activity_info.name : '', item.created_at])
                        ];
                    }else{
                        excelData = [
                            ['ID', '用户名称', '微信ID', '手机', '邮箱', '性别', '年龄', '居住地', '活动名称', '是否商户活动', '参与时间'],
                            ...reqData.map((item) => [item.user_info.id, item.user_info.name, item.user_info.wx_id, item.user_info.account, item.user_info.email, item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置', item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' :  '未设置', item.user_info.country+','+item.user_info.provinces, item.evaluation.name, item.evaluation.is_merchant_activity === 1?'是':'否', item.created_at])
                        ];
                    }

                    var ws = XLSX.utils.aoa_to_sheet(excelData);
                    XLSX.utils.book_append_sheet(wb, ws, excelTitle);
                    XLSX.writeFile(wb, `${this.curInviteObj.name}-邀新转化-下级列表-${excelTitle}.xlsx`);

                    this.$notify.info({
                        title: '消息',
                        message: '请等待, 正在生成Excel表格文件...'
                    });
                
            } catch (e){
                console.log(e)
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        },
    },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.invite-user {
    .lower-level-box {
        margin-top: 20px;

        .level-menu {
            display: flex;
            align-items: center;

            .menu-item {
                cursor: pointer;
                height: 25px;
                margin-right: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
            }

            .active {
                color: #16ccfc;

                &::after {
                    content: '';
                    // margin-top: 6px;
                    position: absolute;
                    bottom: 0px;
                    display: inline-block;
                    height: 2px;
                    width: 75px;
                    background-color: #16ccfc;
                }
            }
        }

        .search_box {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-end;
            margin: 20px 0;
        }
    }
}
</style>